export default __webpack_public_path__ + "static/media/nextArr.ce77c9cd.svg";